const state = () => ({
  errors: [],
});

export const ERRORS_GETTERS = {
  ALL: 'errors'
}

export const ERRORS_ACTIONS = {
  CACHE_ERRORS: 'cacheErrors',
  REMOVE_FROM_CACHE: 'removeFromCache',
}

const ERRORS_MUTATIONS = {
  CACHE_ERRORS: 'cacheErrors',
  REMOVE_FROM_CACHE: 'removeFromCache',
}

const getters = {
  [ERRORS_GETTERS.ALL]: state => () => state.errors
};

const mutations = {
  [ERRORS_MUTATIONS.CACHE_ERRORS]: (state, message) => {
    state.errors.push(message);
  },
  [ERRORS_MUTATIONS.REMOVE_FROM_CACHE]: (state, message) => {
    state.errors.splice(state.errors.indexOf(message), 1);
  },
};

const actions = {
  [ERRORS_ACTIONS.CACHE_ERRORS]: async ({commit}, message) => {
    commit(ERRORS_MUTATIONS.CACHE_ERRORS, message);
  },
  [ERRORS_ACTIONS.REMOVE_FROM_CACHE]: async ({commit}, message) => {
    commit(ERRORS_MUTATIONS.REMOVE_FROM_CACHE, message);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
